import './ImpersonationBanner.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { useAuth } from '../../contexts/auth/AuthContext';
import { useAccount } from '../../contexts/account/AccountContexts';
import { TokenData } from '../../models/auth/TokenData';
import { ADMIN, ACCOUNTS } from '../../routes/path';
import {
  IMPERSONATION_ORIGINAL_TOKEN_KEY,
  IMPERSONATION_TARGET_ID_KEY,
} from '../../constans/constans';

const ImpersonationBanner: React.FC = () => {
  const { t } = useTranslation();
  const { login } = useAuth();
  const { accountResponse } = useAccount();

  const originalTokenRaw = sessionStorage.getItem(IMPERSONATION_ORIGINAL_TOKEN_KEY);

  if (!originalTokenRaw) {
    return null;
  }

  const handleReturnToAdmin = () => {
    try {
      const originalTokenData = JSON.parse(originalTokenRaw) as TokenData;
      const targetId = sessionStorage.getItem(IMPERSONATION_TARGET_ID_KEY);
      login(originalTokenData);
      sessionStorage.removeItem(IMPERSONATION_ORIGINAL_TOKEN_KEY);
      sessionStorage.removeItem(IMPERSONATION_TARGET_ID_KEY);
      // Hard reload (not SPA navigate) so the app re-initialises with the admin token now in
      // localStorage. An in-app navigate hit the Wrapper super-admin guard before accountResponse
      // had refetched, so it bounced to /projects.
      window.location.href = targetId ? `${ADMIN}${ACCOUNTS}/${targetId}` : `${ADMIN}${ACCOUNTS}`;
    } catch {
      sessionStorage.removeItem(IMPERSONATION_ORIGINAL_TOKEN_KEY);
      sessionStorage.removeItem(IMPERSONATION_TARGET_ID_KEY);
    }
  };

  return (
    <div className="impersonation-banner">
      <span className="impersonation-banner__text">
        {t('impersonatingAs', { email: accountResponse?.email ?? '...' })}
      </span>
      <Button
        className="impersonation-banner__btn"
        label={t('returnToAdmin')}
        type="button"
        onClick={handleReturnToAdmin}
      />
    </div>
  );
};

export default ImpersonationBanner;